<template>
  <div class="flex flex-col gap-1 items-start">
    <label
      :for="forId"
      :class="[
        'text-[11px] text-surface-600 uppercase tracking-[0.1em] pl-1',
        fontWeight === 'semibold' ? 'font-semibold' : 'font-medium',
      ]"
      >{{ label }}</label
    >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: true,
  },
  forId: {
    type: String,
    required: true,
  },
  fontWeight: {
    type: String,
    default: 'medium',
  },
})
</script>
